export default {
      id: "trophy-usage",
      viewBox: "0 0 576 512",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#trophy",
      toString: function () {
        return this.url;
      }
    }